import React from 'react';
import omit from 'lodash/omit';
import { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';
import isObject from 'lodash/isObject';
import classNames from 'classnames';

import Button from '../buttons/button';

import styles from './fileField.module.scss';

export type FileFieldProps = {
  change: (name: string, value: boolean) => void;
  label: string;
  required?: boolean;
  input: WrappedFieldInputProps;
  meta: WrappedFieldMetaProps;
  name: string;
};

export const FileField = ({ label, input, required, name, change, meta: { touched, error } }: FileFieldProps) => {
  const currentFile = input.value;
  const getFileName = () => {
    if (input.value.name) {
      return input.value.name;
    }

    return 'Choose File';
  };

  const adaptFileEventToValue = (delegate: any) => (e: any) => {
    const file = e.target.files[0];

    delegate(file);
  };

  const removeImage = () => {
    change(input.name, null);
  };

  return (
    <div className={classNames(styles.fileField, touched && error && styles.error)}>
      <div className={styles.label}>
        {label}
        {required && '*'}
      </div>
      <div className={styles.inputWrapper}>
        {currentFile && !isObject(currentFile) && (
          <p>
            Current: <img src={currentFile} className={styles.filePreview} alt="" />
            <Button type="button" text="Remove" onClick={removeImage} className={styles.addButton} />
          </p>
        )}
        <div>
          <div className="custom-file">
            <input
              {...omit(input, 'value')}
              type="file"
              className="custom-file-input"
              onChange={adaptFileEventToValue(input.onChange)}
              onBlur={adaptFileEventToValue(input.onBlur)}
              id={name}
            />
            <label htmlFor={name} className="custom-file-label">
              {getFileName()}
            </label>
            {touched && error && <div className={styles.errorMessage}>{error}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};
